import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Register from '@/components/Register'
import ResetForm from '@/components/PasswordResetForm'
import AdminWelcome from '@/components/Admin/Welcome'
import CoursesPage from '@/components/Admin/courses/index'
import CreateCourse from '@/components/Admin/courses/CreatePage'
import CourseManager from '@/components/Admin/courses/CourseManager'
import CreateSemester from '@/components/Admin/semesters/CreatePage'
import SemesterManager from '@/components/Admin/semesters/index'
import MasterLogs from '@/components/Admin/masterlogs/index'
import StudentsPage from '@/components/Admin/students/index'
import TeachersPage from '@/components/Admin/teachers/index'
import ParentsPage from '@/components/Admin/parents/index'
import SystemNotificationPage from '@/components/Admin/notifications/index'
import ParentDashboard from '@/components/Parent/ParentDashboard'
import Enrollment from '@/components/Enrollment/index'
import PasswordReset from '@/components/PasswordReset'
import StudentRegistration from '@/components/StudentRegistration/index'
import NotFound from '@/components/NotFound'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Login', component: Login },
    { path: '/registration', name: 'Register', component: Register },
    { path: '/reset-form', name: 'ResetForm', component: ResetForm },
    { path: '/student-registration', name: 'StudentRegistration', component: StudentRegistration },
    { path: '/admin/dashboard', name: 'AdminDashboard', component: AdminWelcome },
    { path: '/admin/dashboard/classes/create/', name: 'AdminCreateClass', component: CreateCourse },
    { path: '/admin/dashboard/classes/:semester_slug/', name: 'AdminClasses', component: CoursesPage },
    { path: '/admin/dashboard/classes/:semester_slug/:course_id', name: 'AdminEditClass', component: CourseManager },
    { path: '/admin/dashboard/semesters/create/', name: 'AdminCreateSemester', component: CreateSemester },
    { path: '/admin/dashboard/semesters/:semester_slug', name: 'AdminEditSemester', component: SemesterManager },
    { path: '/admin/dashboard/logs/:semester_slug', name: 'AdminLogs', component: MasterLogs },
    { path: '/admin/dashboard/users/students', name: 'AdminStudents', component: StudentsPage },
    { path: '/admin/dashboard/users/teachers', name: 'AdminTeachers', component: TeachersPage },
    { path: '/admin/dashboard/users/parents', name: 'AdminParents', component: ParentsPage },
    { path: '/admin/dashboard/notifications', name: 'SystemNotifications', component: SystemNotificationPage },
    { path: '/dashboard', name: 'ParentDashboard', component: ParentDashboard },
    { path: '/enrollment', name: 'Enrollment', component: Enrollment },
    { path: '/pw-reset', name: 'pwreset', component: PasswordReset },
    { path: '/404', alias: '*', name: '404', component: NotFound }
  ]
})

router.beforeEach((to, from, next) => {
  const storage = sessionStorage.getItem('eagleridge.auth')
  const vuex = JSON.parse(storage)

  if (to.name === 'pwreset') {
    next()
    return
  }

  if (storage) {
    if (!vuex.auth.user) {
      switch(to.name) {
        case 'Login':
        case 'Register':
        case 'ResetForm':
        case 'StudentRegistration':
          next()
          return
        default:
          next('/')
          return
      }
    }
  } else if (to.name === 'Login' || to.name === 'Register' || to.name === 'ResetForm' || to.name === 'StudentRegistration') {
    next()
    return
  } else {
    next('/')
    return
  }

  // user is logged in at this point
  switch(to.name) {
    case 'Login':
    case 'Register':
    case 'ResetForm':
      switch(vuex.auth.user.role) {
        case 'admin':
          next({ name: 'AdminDashboard'})
          break
        case 'parent':
          next({ name: 'ParentDashboard'})
          break
      }
      break
    case 'AdminDashboard':
    case 'AdminClasses':
    case 'AdminCreateClass':
    case 'AdminEditClass':
    case 'AdminCreateSemester':
    case 'AdminEditSemester':
    case 'AdminLogs':
    case 'AdminStudents':
    case 'AdminTeachers':
    case 'AdminParents':
    case 'SystemNotifications':
      if (vuex.auth.user.role === 'admin') {
        next()
      } else {
        next(from.path)
      }
      break
    case 'ParentDashboard':
      if (vuex.auth.user.role === 'parent') {
        next()
      } else {
        next(from.path)
      }
      break
    case 'Enrollment':
      if (vuex.auth.user.role === 'admin' || vuex.auth.user.role === 'parent') {
        next()
      } else {
        next(from.path)
      }
      break
    default:
      next()
  }
})

export default router
